import styled, { css } from "styled-components";
import { useDesignTokens } from "@boi/react-design-tokens";

type StrokeWrapperProps = {
  $hasError?: boolean;
};

export const OutlineWrapper = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { outerField } = tokens;

    return css`
      width: 100%;

      outline-color: ${outerField.focusRing.color};
      outline-width: ${outerField.focusRing.width.base};
      outline-style: ${outerField.focusRing.style};
      outline-offset: ${outerField.focusRing.offset.base};
      border-radius: ${outerField.radius};

      &:has(input:not(:read-only):focus),
      &:has(textarea:not(:read-only):focus) {
        outline-width: ${outerField.focusRing.width.focus};
        outline-offset: ${outerField.focusRing.offset.focus};
      }
    `;
  }}
`;

export const StrokeWrapper = styled.div<StrokeWrapperProps>`
  ${({ $hasError }) => {
    const { tokens } = useDesignTokens();
    const { outerField } = tokens;

    return [
      css`
        position: relative;
        width: 100%;
        background: ${outerField.backgroundColor};

        outline-color: ${outerField.stroke.color.base};
        outline-width: ${outerField.stroke.width.base};
        outline-offset: ${outerField.stroke.offset.base};
        outline-style: ${outerField.stroke.style};
        border-radius: ${outerField.radius};

        ${OutlineWrapper}:has(input:not(:disabled):not(:read-only)):hover &&,
        ${OutlineWrapper}:has(textarea:not(:disabled):not(:read-only)):hover && {
          outline-color: ${outerField.stroke.color.hover};
          outline-width: ${outerField.stroke.width.hover};
          outline-offset: ${outerField.stroke.offset.hover};
        }

        ${OutlineWrapper}:has(input:read-only) &&,
        ${OutlineWrapper}:has(textarea:read-only) && {
          outline-color: ${outerField.stroke.color.readOnly};
        }

        ${OutlineWrapper}:has(input:focus:not(:read-only)) &&,
        ${OutlineWrapper}:has(textarea:focus:not(:read-only)) && {
          outline-color: ${outerField.stroke.color.focus};
          outline-width: ${outerField.stroke.width.focus};
          outline-offset: ${outerField.stroke.offset.focus};
        }
      `,
      $hasError &&
        css`
          &&,
          ${OutlineWrapper}:has(input:read-only) &&,
          ${OutlineWrapper}:has(input:disabled) &&,
          ${OutlineWrapper}:has(textarea:read-only) &&,
          ${OutlineWrapper}:has(textarea:disabled) && {
            outline-width: ${outerField.stroke.width.error};
            outline-color: ${outerField.stroke.color.error};
            outline-offset: ${outerField.stroke.offset.error};
          }
        `,
    ];
  }}
`;
